import { SCAN_ACTION_EXECUTION_REGISTRY } from '../constants/scanActionExecutionRegistry.const';
import { OPEN_ORDER_DRAWER_SCAN_ACTION_NAME } from '../constants/scanActionNames.const';
import { type ScanAction, type ScanActionResult } from '../types/scanAction.type';
import { type ScanEvent } from '../types/scanEvent.type';

const isOrderDrawerMatch = (scanEvent: ScanEvent) => {
  const barcodeContent = scanEvent.scanContext.barcodeContent;
  if (!barcodeContent) return false;

  const { route, ui } = scanEvent.scanContext;
  if (route.route === 'orders') {
    return (
      !ui.openDrawer ||
      ui.selectedOrderObjectId !== barcodeContent.orderObjectId ||
      ui.selectedShipmentId !== barcodeContent.shipmentId
    );
  }

  if (route.route === 'shipments') {
    if (!barcodeContent.transactionObjectId) return false;
    return (
      !ui.openDrawer ||
      ui.selectedOrderObjectId !== barcodeContent.orderObjectId ||
      ui.selectedTransactionObjectId !== barcodeContent.transactionObjectId
    );
  }

  return false;
};

export const createOpenOrderDrawerScanAction = (): ScanAction => ({
  execute: (scanEvent: ScanEvent): ScanActionResult => {
    SCAN_ACTION_EXECUTION_REGISTRY.execute(OPEN_ORDER_DRAWER_SCAN_ACTION_NAME, scanEvent);
    return { success: true };
  },

  matches: (scanEvent) =>
    SCAN_ACTION_EXECUTION_REGISTRY.has(OPEN_ORDER_DRAWER_SCAN_ACTION_NAME) &&
    isOrderDrawerMatch(scanEvent),

  name: OPEN_ORDER_DRAWER_SCAN_ACTION_NAME,
});
